import {inject} from 'aurelia-framework';
import {UserService} from '../Advertiser.SharedPortal/services/user-service';

@inject( UserService )
export class Logout {
   constructor( userService ) {
      this.userService = userService;
      this.submitted = false;
   }

   activate() {
      this.userService.logout();
      this.submitted = true;
   }
}
